import React from "react"
import type { Condition } from "./types"
import { OPERATOR_OPTIONS, INPUT_CLASS } from "./constants"
import { XIcon } from "./icons"

interface ConditionRowProps {
  condition: Condition
  index: number
  onChange: (index: number, field: keyof Condition, value: string) => void
  onRemove: (index: number) => void
  valueSuggestions?: string[]
  fieldOptions: Array<{ label: string; value: string }>
}

export function ConditionRow({
  condition,
  index,
  onChange,
  onRemove,
  valueSuggestions,
  fieldOptions,
}: ConditionRowProps) {
  const datalistId = `condition-values-${index}`
  const hasSuggestions = valueSuggestions && valueSuggestions.length > 0

  return (
    <div
      className="flex items-center gap-2 mb-2"
      data-testid={`condition-row-${index}`}
    >
      <select
        value={condition.field}
        onChange={(e) => onChange(index, "field", e.target.value)}
        className={`flex-1 ${INPUT_CLASS}`}
      >
        {fieldOptions.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>

      <select
        value={condition.operator}
        onChange={(e) => onChange(index, "operator", e.target.value)}
        className={`flex-1 ${INPUT_CLASS}`}
      >
        {OPERATOR_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>

      <input
        type="text"
        value={condition.value}
        onChange={(e) => onChange(index, "value", e.target.value)}
        className={`flex-1 ${INPUT_CLASS}`}
        placeholder={hasSuggestions ? "Type or select..." : "Value..."}
        list={hasSuggestions ? datalistId : undefined}
      />
      {hasSuggestions && (
        <datalist id={datalistId}>
          {valueSuggestions.map((v) => (
            <option key={v} value={v} />
          ))}
        </datalist>
      )}

      <button
        type="button"
        onClick={() => onRemove(index)}
        className="p-1 text-gray-400 hover:text-red-600"
        aria-label="Remove condition"
      >
        <XIcon size={14} />
      </button>
    </div>
  )
}
